import ShowocaseLayout from '../../../../components/layout/ShowocaseLayout';
import AsyncPage from './async';
import React from 'react';

export default [
  <ShowocaseLayout
    key="/business/showcase/scarves"
    exact
    path="/business/showcase/scarves"
    component={AsyncPage}
  />,
];

